<template>
  <div class="home paris">
    <HeroImage
      :isHome="true"
      post='from out of bed to the day ahead, <br class="d-none d-lg-block">entrepreneur and ADHD advocate <br class="d-none d-lg-block">Paris Hilton rises and shines with <br class="d-none d-lg-block">JORNAY PM'
      alt="rise & shine"
      copy="JORNAY PM is taken at night and starts working as people rise, so they’re ready to shine with ADHD symptom support that lasts into the early evening."
      subtitle="JORNAY PM is taken at night and starts working as people rise, so they’re ready to shine with ADHD symptom support that lasts into the early evening."
      :image="heroImg"
      :image__sm="mobileImg"
    >
    </HeroImage>

    <Journey />

    <PageNav :menus="navItems" />

    <InfoBlockSticky />
    <InfoBlock class="trigger" />
    <Footer />
  </div>
</template>

<script>
import HeroImage from "../../components/elements/HeroImage-paris.vue";
import Journey from "../../components/sections/Journey-paris.vue";
import InfoBlock from "../../components/sections/InfoBlock";
import InfoBlockSticky from "../../components/sections/InfoBlockSticky";
import Footer from "../../components/sections/Footer";
import heroImg from "../../assets/images/3_25/home/hero@2x-2.webp";
import mobileImg from "../../assets/images/3_25/home/hero_s@2x-2.webp";
import ogImage from "../../assets/images/Jornay_OG_Image.jpg";
import PageNav from "../../components/elements/PageNav.vue";

export default {
  name: "home",
  metaInfo: {
    title: "Discover JORNAY PM® (methylphenidate HCI) for ADHD",
    link: [
      {
        rel: "canonical",
        href: "https://www.jornaypm.com/",
      },
    ],
    meta: [
      {
        name: "description",
        content:
          "Learn about JORNAY PM® (methylphenidate HCI extended-release capsules), a prescription medication for treating ADHD in patients 6 years and older. Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
      },
      {
        property: "og:title",
        content: "Discover JORNAY PM® (methylphenidate HCI) for ADHD",
      },
      {
        property: "og:description",
        content:
          "Learn about JORNAY PM® (methylphenidate HCI extended-release capsules), a prescription medication for treating ADHD in patients 6 years and older. Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
      },
      {
        property: "og:image",
        content: ogImage,
      },
      {
        property: "google-site-verification",
        content: "ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I",
      },
    ],
  },
  components: {
    HeroImage,
    Journey,
    InfoBlock,
    InfoBlockSticky,
    Footer,
    PageNav,
  },
  data() {
    return {
      quizHeadings: [
        "Is ADHD affecting how your day starts?",
        "It's time to take the <b>Rate My Morning Quiz</b>, and talk to your doctor<br>because how the day starts is important.",
      ],
      heroImg,
      mobileImg,
      navItems: [
        {
          title: "Get the facts on JORNAY&nbsp;PM",
          routerLinkName: "About",
          ctaText: "START HERE",
        },
        {
          title: "See how JORNAY PM works",
          routerLinkName: "How",
          ctaText: "LEARN MORE",
        },
      ],
    };
  },
  mounted() {
    if (location.hash.length) {
      const elementFaqId = "#quiz";
      const elementFaqItem = document.querySelector(elementFaqId);
      const elementFaqPositionTop = elementFaqItem.offsetTop;
      window.scrollTo(0, elementFaqPositionTop);
    }
    if (sessionStorage.getItem("router")) {
      this.$router.push(sessionStorage.getItem("router"));
    }

    let onChange = ([el]) => {
      if (el.isIntersecting) {
        e.classList.add("d-none");
        e.classList.add("intersecting");
      } else {
        e.classList.remove("d-none");
        e.classList.remove("intersecting");
      }
    };

    let e = document.querySelector(".sticky");
    let element = document.querySelector(".trigger");
    let observer = new IntersectionObserver(onChange, {
      root: null,
      rootMargin: "200px 0px 200px 0px",
      threshold: 0,
    });

    observer.observe(element);

    let lastScrollTop = 0;

    window.addEventListener("scroll", (ev) => {
      let st = window.pageYOffset || document.documentElement.scrollTop;
      let h = window.innerHeight;
      let delta = element.offsetTop - st - h;
      if (
        e.classList.contains("d-none") &&
        st < lastScrollTop &&
        delta >= -190
      ) {
        e.classList.remove("d-none");
      } else if (st > lastScrollTop && e.classList.contains("intersecting")) {
        e.classList.add("d-none");
      }
      lastScrollTop = st <= 0 ? 0 : st;
    });
  },
  destroyed() {
    sessionStorage.removeItem("router");
  },
};
</script>
